import { useEffect, useState } from "react";

export default function useCategories() {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    async function fetchCategories() {
      try {
        const res = await fetch("/api/products");
        const data = await res.json();

        // Ensure data.products exists
        const products = data.products || [];

        const all = new Set();

        // Use collectionName as category
        products.forEach((p) => {
          if (p.collectionName) all.add(p.collectionName);
        });

        setCategories([...all]);
      } catch (err) {
        console.error("Failed loading categories:", err);
      }
    }

    fetchCategories();
  }, []);

  return categories;
}
